/**
 * 项目基础信息实体
 * zxw
 * 创建时间：
 * 修改时间：2026-07-09
 */

import { useState, useEffect } from 'react';
import {
    Modal,
    Input,
    Row,
    Col,
    message,
    Select,
    Flex,
    Typography,
} from 'antd';
import $ from 'jquery';
import { AddRequestHeaders } from '../../incs/FunHelper';
import CNF from '../../incs/Config';

const MODULENAME = '项目';

const { TextArea } = Input;
const { Text } = Typography;

const MODULENAME_URL = CNF.navItems[0].submenu[0].url;

const Entity = (props) => {
    const { open, setOpen, record, refresh, btnLists } = props;
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [number, setNumber] = useState('');
    const [name, setName] = useState('');
    const [type, setType] = useState('');
    const [phase, setPhase] = useState('');
    const [area, setArea] = useState('');
    const [maintenanceContent, setMaintenanceContent] = useState('');
    const [description, setDescription] = useState('');

    const cancel = () => {
        setOpen(false);
        setLoading(false);
        setNumber('');
        setName('');
        setType('');
        setPhase('');
        setArea('');
        setMaintenanceContent('');
        setDescription('');
    };

    useEffect(() => {
        // 修改初始化
        if (open && record) {
            setNumber(record.number);
            setName(record.name);
            setType(record.type);
            setPhase(record.phase);
            setArea(record.area);
            setMaintenanceContent(record.maintenance_content);
            setDescription(record.description);
        }
    }, [open, record]);

    const ok = () => {
        //  参数校验
        if (number === '') {
            messageApi.error('项目编号不能为空！');
            return;
        }
        if (name === '') {
            messageApi.error('项目名称不能为空！');
            return;
        }
        if (area === '') {
            messageApi.error('项目区域不能为空！');
            return;
        }
        if (type === '') {
            messageApi.error('项目类型不能为空！');
            return;
        }
        if (phase === '') {
            messageApi.error('项目阶段不能为空！');
            return;
        }
        setLoading(true);

        $.ajax({
            url: CNF.api + MODULENAME_URL.slice(1) + (record ? '/' + record.key : ''),
            headers: AddRequestHeaders(),
            type: record ? 'PUT' : 'POST',
            dataType: 'JSON',
            data: JSON.stringify({
                number: number,
                name: name,
                type: type,
                phase: phase,
                area: area,
                maintenance_content: maintenanceContent,
                description: description
            }),
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    cancel();
                    refresh();
                }, CNF.messageDuration * 1000);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        }).always(() => setTimeout(function () {
            setLoading(false)
        }, CNF.messageDuration * 1000))
    };


    return (
        <>
            {contextHolder}
            <Modal
                style={{ top: 0 }}
                width={600}
                title={(record ? CNF.actionName.UPDATE : CNF.actionName.CREATE) + MODULENAME}
                open={open}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ disabled: loading }}
            >
                <Flex vertical gap='small'>
                    <Row>
                        <Col span={24}><Text>项目编号</Text><Text type='danger'>*</Text></Col>
                        <Col span={24}>
                            <Input
                                placeholder='请输入'
                                value={number}
                                onChange={(e) => setNumber(e.target.value)}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}><Text>项目名称</Text><Text type='danger'>*</Text></Col>
                        <Col span={24}>
                            <Input
                                placeholder='请输入'
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}><Text>项目区域</Text><Text type='danger'>*</Text></Col>
                        <Col span={24}>
                            <Input
                                placeholder='请输入'
                                value={area}
                                onChange={(e) => setArea(e.target.value)}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={11}><Text>项目类型</Text><Text type='danger'>*</Text></Col>
                        <Col span={12} offset={1}><Text>项目阶段</Text><Text type='danger'>*</Text></Col>
                        <Col span={11}>
                            <Select
                                placeholder='项目类型'
                                style={{ width: '100%' }}
                                value={type || undefined}
                                onChange={(value) => setType(value)}
                                options={CNF.projectTypes.map((item, index) => ({
                                    key: index,
                                    value: item.value,
                                    label: item.key
                                }))}
                            />
                        </Col>
                        <Col span={12} offset={1}>
                            <Select
                                placeholder='项目阶段'
                                style={{ width: '100%' }}
                                value={phase || undefined}
                                onChange={(value) => setPhase(value)}
                                disabled={loading}
                                options={CNF.projectPhases.map((item, index) => ({
                                    key: index,
                                    value: item.value,
                                    label: item.key
                                }))}
                            />
                        </Col>
                    </Row>
                    {
                        // 项目运维角色可见
                        btnLists.indexOf('btn_plms_om') >= 0 && (
                            <Row>
                                <Col span={24}><Text>维护内容</Text></Col>
                                <Col span={24}>
                                    <TextArea
                                        placeholder='请输入'
                                        rows={2}
                                        autoSize={{ minRows: 4, maxRows: 6 }}
                                        value={maintenanceContent}
                                        onChange={(e) => setMaintenanceContent(e.target.value)}
                                        disabled={loading}

                                    />
                                </Col>
                            </Row>
                        )}
                    <Row>
                        <Col span={24}><Text>备注说明</Text></Col>
                        <Col span={24}>
                            <TextArea
                                placeholder='请输入'
                                rows={2}
                                autoSize={{ minRows: 3, maxRows: 3 }}
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                </Flex>
            </Modal>
        </>
    );
}

export default Entity